"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionCreators = _interopRequireDefault(require("../../change/ActionCreators"));

var _default = function _default(_this) {
  return {
    deleteSelf: function deleteSelf() {
      _this.dispatch(_ActionCreators.default.deleteSelf());
    }
  };
};

exports.default = _default;